import { AxiosResponse } from "axios";
import { GetOperatorAttributeValueOpts } from "../../../models/Api/Attribute";
import { axiosInstance } from "../../../../../axiosInstance";

export const getOperatorAttributeValue = async ({
  operatorId,
  attributeKeyName,
}: GetOperatorAttributeValueOpts): Promise<AxiosResponse> => {
  return axiosInstance
    .get(`/operators/${operatorId}/attributes/${attributeKeyName}`)
    .catch(error => {
      return error.response;
    });
};
